export default {
	home: 'Iniciação',
	aboutUs: 'Nós',
	contact: 'Contato',
	logout: 'Fechar sessão',
	login: 'Iniciar sessão',
	register: 'CADASTRE-SE AQUI',
	search: 'Pesquisa',
	login_fa: 'Login com o facebook',
	login_go: 'login com o Google',
	sign_in_man: 'Faça o login manualmente',
	username: 'Nome de usuário',
	password: 'senha',
	btn_register: 'Registrar agora',
	btn_lost_pass: 'Esqueceu a senha?',
	text_remenber: 'lembrar',
	check_in: 'Registre-se',
	itfa_abr: 'ASOCIACIÓN INDEPENDIENTE TELEFOOTBALL',
	select_platform: 'Selecciona uma plataforma',
	about_us: `<p>Con el fin de conseguir lo más cercano a <strong>nuestra manera</strong> de dirigir una competición lo mas real que se pueda en FIFA nos gustaría resaltar algunos detalles sobre lo que es su experiencia en este juego.</p><p>Actualmente tenemos alrededor de 800+ jugadores en nuestros Pro Clubes y Grupos 1vs1 esta proximamente a realizarse, donde muchos están involucrados en una u otra de las competencias que son exclusivas para PS4 debido a diversas razones.</p><p>Esta página web, esta echa para todos ustedes donde habra torneos sobre FIFA 16.</p><p>– 1 VS 1 donde podras demostrar tu habilidad.</p><p>– PRO CLUBS es un modo de juego online de FIFA 16 donde puedes crear un jugador Virtual Pro y jugar en tu misma posición en el campo con tus compañeros del modo más realista que puedes vivir el fútbol online. Cuantos más partidos juegues y más hazañas desbloquees, tu Virtual Pro desbloqueará mejores atributos y más opciones de aspecto. Juega partidos informales o bien únete a un club o crea el tuyo para conseguir puntos con tu propio club.</p><p>También podrá interactuar con nosotros,mardar las fotos de tu club oh videos, contactarnos, hacer preguntas y enviar sugerencias y comentarios relacionados con nuestra forma de como llevamos la pagina web y administracion, asegurando poder atenderlos y responderle lo mas pronto posible con algun problema que tengan.</p><p><strong>Un cordial saludo.</strong></p><p>Esperamos poder cumplir con sus expectativas con calidad rapidez y satisfacción, ya que es nuestra verdadera filosofía de trabajo fifa.</p>`,
	text_contact:
		'<p>Obrigado por sua visita.</p><p>Se você tiver quaisquer sugestões, reclamações ou comentários por favor escreva, Teremos o maior prazer em responder.</p>',
	subject: 'Questão',
	email: 'Correio eletrônico',
	name: 'Nome',
	message: 'Mensaje',
	messages: 'Mensajes',
	required: 'Necessário',
	submit: 'Enviar',
	return: 'Retorno',
	pleaseWait: 'Espere, por favor...',
	registerTitle: 'Registro do usuário',
	repeatPassword: 'Repita sua senha',
	country: 'Country',
	position: 'Posição',
	console: 'Consola',
	motto: 'Lema',
	selectOption: 'Selecionar uma opção',
	allRightsReserved: 'Todos os direitos reservados.',
	profile: 'Perfil',
	myProfile: 'Meu perfil',
	friends: 'Amigos',
	edit: 'Editar',
	myNews: 'Minhas notícias',
	editUser: 'Editar minhas informações',
	language: 'Idioma',
	save: 'Salvar',
	changePassword: 'Alterar senha',
	currentPassword: 'Senha atual',
	newPassword: 'Nova senha',
	repeatNewPassword: 'Repita nova senha',
	options: 'Opções',
	favorites: 'Favoritos',
	createAdmins: 'Crie administradores',
	sliderPrimary: 'Slider Principal',
	changeGt: 'Mudar gamertag',
	toPremium: 'Mudar para premium',
	updatedData: 'Actualizar Datos',
	tutorialCreate: 'Criar tutorial',
	bets: 'Apostas',
	textChangeImgSlider:
		'<li>A imagem não deve ter um peso maior 2 MB.</li><li>resolução mínima 1366 x 598 pixeles.</li><li>a única extensão é permitido JPG.</li>',
	findImage: 'Busca da imagem',
	details: 'Detalhes',
	updatedInfo: 'Informação atualizada.',
	create: 'Criar',
	title: 'Título',
	delete: 'Excluir',
	error404: 'O recurso não existe.',
	enterUserId: 'Digite um ID de usuário',
	cancel: 'Cancelar',
	confirmTitleDelete: 'Confirme a exclusão',
	confirmTextDelete: '¿Tem certeza que quer excluir o item selecionado?',
	editInfoUser: 'Editar informações usuário',
	resetPassword: 'Restabelecer a senha',
	enterYourEmail: 'Digite o seu e-mail',
	image: 'Imagem',
	published: 'Publicado',
	modified: 'Modificado',
	comments: 'Comentes',
	date: 'Data',
	time: 'Tempo',
	createdAgo: 'Criado atrás',
	content: 'Conteúdo',
	cover: 'Cobrir',
	show: 'Mostrar',
	enterIdOrUsername: 'Digite o ID ou o nome de um jogador',
	month: 'mês | meses',
	year: 'ano | anos',
	selectPlatform: 'Selecciona uma plataforma',
	langEs: 'Espanhol',
	langEn: 'Inglês',
	langPt: 'Portugues',
	description: 'Descrição',
	videoCode: 'Código del video',
	order: 'Ordem',
	tournaments: 'Torneios',
	tournament: 'Torneio',
	online: 'Online',
	notices: 'Notícias',
	readMore: 'Ler mais',
	seeAllNews: 'Veja todas as novidades',
	rankingPlayers: 'Ranking de jogadores',
	rankingTeams: 'Ranking das equipes',
	lastMatches: 'Últimos jogos',
	round: 'rodada | rodadas',
	theBest: 'Os melhores',
	signings: 'Transferências',
	rules: 'Regras',
	divisions: 'Divisões',
	division: 'Divisõe',
	teams: 'Equipes',
	team: 'Equipamento',
	transfers: 'Transferências',
	assistances: 'Asistencias',
	scorer: 'Marcador | Artilheiros',
	transferClose: '{time} restantes até o fechamento',
	transferOpen: '{time} para abrir',
	goal: 'gol | gols',
	assistance: 'assistência | assistências',
	goalkeeper: 'Goleiro | Goleiros',
	bestPlayer: 'Melhor jogador',
	point: 'ponto | pontos',
	bestDefense: 'A melhor defesa',
	bestOffensive: 'A melhor ofensiva',
	goalFavor: 'gol a favor | gols a favor',
	goalAgainst: 'gol contra | gols contra',
	player: 'Jogador',
	players: 'Jogadores',
	ranking: 'Classificação',
	status: 'Status',
	price: 'Preço',
	purchasedBy: 'Comprado pelo',
	availableMoney: 'Dinheiro disponível',
	free: 'Grátis',
	signing: 'Assinado',
	playedGames: 'Partidas disputadas',
	yellowCard: 'cartão amarelo | cartões amarelos',
	redCard: 'cartão vermelho | cartões vermelhos',
	joinTheMarket: 'Junte-se ao mercado',
	joinTheMarketConfirm:
		'Tem certeza de que deseja participar da lista de jogadores gratuitos no torneio?',
	yes: 'Sim',
	not: 'Não',
	notice: 'Aviso',
	contract: 'Contratar',
	sellPlayers: 'Vender jogadores',
	pendingRounds: 'Rodadas pendentes',
	sellerPlayerConfirm:
		'Tem certeza de que deseja vender para o jogador selecionado?',
	table: 'Tabela',
	card: 'cartão | cartãos',
	teamWeek: 'Equipa da semana',
	nextMatches: 'Próximos jogos',
	results: 'Resultados',
	privateMsgFor: 'Mensagem privada para {user}',
	pj: 'PJ',
	pg: 'PG',
	pe: 'PE',
	pp: 'PP',
	gf: 'GF',
	gc: 'GC',
	dg: 'DG',
	seeDT: 'Veja DT',
	matches: 'Jogos',
	quantity: 'Quantidade',
	training: 'Treinamento',
	defenses: 'Defesas',
	midfielders: 'Meio-campistas',
	front: 'Frente',
	award: 'prêmio | prêmios',
	champion: 'CAMPEÃO',
	stats: 'Estatísticas',
	type: 'Digitar',
	record: 'História',
	changeImage: 'Alterar imagem',
	addTeam: 'Adicionar equipe',
	textFindNotice: 'Digite uma ou mais letras e pressione ENTER',
	sendInvitation: 'Enviar convite',
	createTournament: 'Criar torneio',
	editTournament: 'Editar torneio',
	mode: 'mode',
	category: 'categoria | categorias',
	hideTournament: 'Esconder torneio?',
	deleteAllPlayersOfTeam:
		'Tem certeza de excluir todos os jogadores da equipe selecionada?',
	handOutMoney: 'Mão de dinheiro',
	add: 'Adicionar',
	remove: 'Remover',
	transfersClosed: 'Transferências - está fechado',
	transfersOpened: 'Transferência - está aberto',
	transfersClosedMsg:
		'A transferência é fechada, os jogadores que foram convidados poderão entrar na equipe.',
	transfersOpenedMsg:
		'A transferência está aberta, os jogadores que foram convidados e não aceitaram não podem entrar na equipe até a próxima assinatura.',
	open: 'Abrir',
	close: 'Fechar',
	customButtons: 'Botões personalizados',
	label: 'Rótulo',
	showIn: 'Mostrar em',
	selfLink: 'Na mesma página',
	blankLink: 'Em outra pagina',
	views: 'Views',
	administrator: 'administrador | administradores',
	enterPlayerNick: 'Digite o apelido de um jogador',
	user: 'utilizador',
	roundsFinalPhase: 'ROUNDS + FASE FINAL',
	allFinalPhase: 'TODOS CONTRA TUDO + FASE FINAL',
	manualDirectDisposal: 'DISPOSIÇÃO DIRECTA MANUAL',
	autoDirectDisposal: 'DISPOSIÇÃO DIRECTA AUTOMÁTICA',
	numberTeamsDown: 'Number of teams that are down',
	numberTeamsPassLiguilla: 'Número de equipas que vão para os playoffs',
	season: 'temporada | estações',
	deliverCup: 'Copo de entrega',
	removeCup: 'REMOVER O COPO',
	toStart: 'PRESTES A COMEÇAR',
	programming: 'NA PROGRAMAÇÃO',
	inProgress: 'EM CURSO',
	finished: 'CONCLUÍDO',
	notPresented: 'GANHOU POR PADRÃO',
	played: 'JOGOU',
	changeDatesRounds: 'Alterar as datas das rodadas',
	addPlayTime: 'Agregar horario de juego',
	selectDays: 'Selecione um ou mais dias por semana',
	monday: 'segunda-feira',
	tuesday: 'terça-feira',
	wednesday: 'quarta-feira',
	thursday: 'quinta-feira',
	friday: 'sexta-feira',
	saturday: 'Sábado',
	sunday: 'Domingo',
	schedule: 'Jogo de calendário',
	transferDate: 'Transferência de data',
	dateNextSigning: 'Próxima data de assinatura',
	endDate: 'Data de fechamento',
	choose: 'Selecione',
	alternate: 'Alternativo',
	showFixture: 'Mostrar acessório',
	msgCreateFixture:
		'Depois de criar o dispositivo elétrico já você não pode adicionar mais equipamentos ao torneio. Claro que para continuar?',
	createFixture: 'Criar fixture',
	btnIfContinue: 'Si, desejo de continuar',
	createLiguilla: 'Criar a liga',
	thirdPlace: 'Terceiro lugar',
	myClub: 'Meu clube',
	myTeams: 'Minhas equipes',
	myGames: 'Meus jogos',
	management: 'Gestão',
	tshirts: 'T-shirts',
	notification: 'notificação | notificações',
	from: 'De',
	detailsNotification: 'Detalhes da notificação',
	invitation: 'convites | convites',
	accept: 'Aceitar',
	deny: 'Rejeitar',
	invitationAccepted: 'Convite aceito.',
	invitationRejected: 'Convite rejeitado.',
	transferPlayer: 'Transferir jogador',
	freePlayerPremium: 'Você quer liberar o jogador selecionado?',
	trainingShow: 'Treinamento para mostrar',
	teamFormation: 'Formação de equipe',
	myFormation: 'Meu treinamento',
	invitePlayers: 'Jogadores convidados',
	myFavouriteTeams: 'Meus times favoritos',
	myFavouriteTournaments: 'Meus torneios favoritos',
	visitor: 'Visitante',
	watchMatch: 'Assistir jogo',
	editVideos: 'Editar videos',
	addPictures: 'Adicionar imagens',
	toUpdate: 'Atualização',
	editMatch: 'Editar jogo',
	participated: 'Participou',
	none: 'Nenhum',
	changeResultMatch: 'Alterar um resultado',
	changeResults: 'Alterar os resultados',
	changeStatistics: 'Mudar de estatísticas',
	enabledStatistics: 'Ativar estatísticas edição',
	all: 'All',
	coins: 'Monedas',
	duration: 'Duração',
	toBuy: 'Comprar',
	relatedProducts: 'Produtos relacionados',
	boughtOn: 'Comprado el',
	beatOn: 'Vence el',
	use: 'USE',
	addCategory: 'Adicionar categoria',
	bgTournaments: 'Imagem de fundo para os torneios',
	bgDivisions: 'Imagem de fundo para divisões',
	bgTeams: 'Imagem de fundo para equipes',
	bgPlayers: 'Imagem de fundo para os jogadores',
	editCategory: 'Editar categoria',
	addSubcategory: 'Adicionar subcategoria',
	editSubcategory: 'Editar subcategoria',
	createProduct: 'Criar produto',
	visible: 'Visible',
	editProduct: 'Editar produto',
	cardNumber: 'Número de cartão',
	expirationDate: 'Data de expiração',
	matchBetting: 'Apostas em partidas',
	matchWin: 'Jogo, vitória',
	bet: 'Aposta',
	gain: 'Ganho',
	matchesBet: 'Jogos com aposta',
	betMsgEntry:
		'Ele irá deduzir (<strong>{coin}</strong>) de suas moedas para jogar este jogo',
	confirmResults: 'Confirme os resultados',
	whatLokingFor: '¿O que você está buscando?',
	textFind: 'Digite as 3 letras ou caracteres',
	searchResults: 'Resultados da sua pesquisa',
	seeCard: 'Ver cartão',
	only15Letters: 'Apenas 15 caracteres.',
	rename: 'Mudar de nome',
	sendLinkResetPassword: 'Email alterar a senha',
	end: 'FIM',
	deliverPrizes: 'Entregar prêmios',
	confirm: 'Confirmar',
	awardsConfirmText:
		'Você tem certeza de continuar? <br/>Esta opção não pode ser desfeita.',
	donateTitle: 'Agradecemos o apoio prestado',
	donateThanks: 'Obrigado por seu apoio.',
	donateText:
		'<p>A organização ITFA America agradece a todas as pessoas que, de uma forma ou de outra, apreciam o árduo trabalho realizado pela administração desta página em que são organizados múltiplos torneios de grande renome e alta competitividade.</p><p>A todos esses patrocinadores que executam anonimamente.</p><p>Agradecemos a contribuição, pois nos motivam a continuar com este excelente projeto, melhorando a página e mantendo-a.</p>',
	donate: 'doar | doações',
	amountToDonate: 'Quantidade para doar',
	premiumForMonth: 'Preço válido por 1 mês | Preço válido por {month} meses',
	priceForMonth: '1 mês | {month} meses',
	movements: 'Movimentos',
	transferIn: '{player} é agora jogador do {team}',
	transferOut: '{player} deixou o clube {team}',
	changeCup: 'Alterar copo',
	banned: 'Banido',
	reason: 'Razão',
	bannedStart: 'Iniciado',
	bannedEnd: 'Banhado',
	countries: 'Países',
	change: 'Mudar',
}
